export default __webpack_public_path__ + "static/media/icon-uparrow.7985c35f.svg";